import axios from 'axios';

export class UserService {
  static loadUserId = async (): Promise<string> => {
    const { data } = await axios.get(`/get/login/me`);
    return data.user_id;
  };
}
